var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AppBar'),_c('v-main',[_c('div',{staticClass:"d-flex justify-space-around align-center flex-column",staticStyle:{"width":"100%","height":"100%"}},[_c('div'),_c('StartButton'),_c('FalseStartButton')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }